import React from 'react';
import { Create, SimpleForm } from 'react-admin';

import { CustomToolbar, Grid } from '../../components'
import DepartmentFields from './DepartmentFields'

export const DepartmentCreate = props => (
  <Create {...props}>
    <SimpleForm toolbar={<CustomToolbar />} redirect="list" >
      <Grid container spacing={8}>
        <DepartmentFields />
      </Grid>
    </SimpleForm>
  </Create>
);

export default DepartmentCreate
